import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "df-complete" };
const _hoisted_2 = {
    class: "df-complete__title",
    tabindex: "-1"
};
const _hoisted_3 = ["innerHTML"];
import { computed } from "vue";
import DOMPurify from "dompurify";
import { useDonation } from "../context/donationContext";
import { useChrome } from "../i18n/useChrome";
import CheckBadge from "../components/ui/CheckBadge.vue";
import BaseButton from "../components/ui/BaseButton.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'StepThankYou',
    setup(__props) {
        // SYNC: see ../_SYNC.md.
        const { message, previewOutcome, back } = useDonation();
        const { tf } = useChrome();
        const OUTCOME_META = {
            ThankYou: { key: "success", glyph: "✓" },
            PaymentFailed: { key: "failure", glyph: "✕" },
            Cancelled: { key: "cancelled", glyph: "ℹ" },
            Pending: { key: "pending", glyph: "⏳" },
        };
        const outcomeMeta = computed(() => OUTCOME_META[previewOutcome.value]);
        const bodyMessage = computed(() => message(previewOutcome.value) || tf(`return.${outcomeMeta.value.key}.body`));
        const bodyHtml = computed(() => DOMPurify.sanitize(bodyMessage.value));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(CheckBadge, { class: "df-complete__badge" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(outcomeMeta.value.glyph), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(tf)(`return.${outcomeMeta.value.key}.title`)), 1 /* TEXT */),
                _createElementVNode("div", {
                    class: "df-complete__sub",
                    innerHTML: bodyHtml.value
                }, null, 8 /* PROPS */, _hoisted_3),
                _createVNode(BaseButton, {
                    variant: "link",
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_unref(back)()))
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(tf)("thankYou.previewBack")), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
